import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link as ReactRouterLink } from 'react-router-dom'
import styles from './link.module.scss'

const Link = (props) => {
  const {
    id,
    onClick,
    to,
    underline,
    margin,
    block,
    center,
    disabled,
    children,
    className
  } = props

  const linkStyles = {}

  if (underline) linkStyles.textDecoration = 'underline'

  const linkClass = classNames(styles.link, className, {
    [styles.underline]: underline,
    [styles.disabled]: disabled,
    [styles.center]: center
  })

  if (margin) {
    linkStyles.display = 'inline-block'
    linkStyles.margin = margin
  }

  if (block) {
    linkStyles.display = 'block'
  }

  return (
    <div className={linkClass} style={linkStyles} id={id} onClick={onClick}>
      <ReactRouterLink to={to}>{children}</ReactRouterLink>
    </div>
  )
}

Link.defaultProps = {
  to: '',
  underline: false,
  margin: null,
  block: false,
  disabled: false,
  className: null,
  center: false,
  children: null,
  id: null,
  onClick: null
}

Link.propTypes = {
  to: PropTypes.string,
  underline: PropTypes.bool,
  margin: PropTypes.string,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  center: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func
}

export default Link
